import React from 'react'

import { css } from 'design'
import { cn } from 'util/cn'

import { ETS, Timestamp } from './timestamp'

export default function DayDivider({ created_at }: { created_at: Date }) {
  return (
    <div
      className={cn(`topic-elems__container__item--day_splitter`)}
      style={{ position: 'relative' }}
      key={'day-' + created_at}
      data-timeline-id={'day-' + created_at}
      role="listitem"
      tabIndex={-1}
    >
      <hr className={hrStyles()} />
      <Timestamp
        className={cn(dayDividerStyles(), 'timeline__status__timestamp')}
        date={created_at.toString()}
        timeStyle={ETS.day}
      />
    </div>
  )
}

const hrStyles = css({
  border: '.5px solid $grey100',
  borderTop: 0,
  borderLeft: 0,
  borderRight: 0,
  marginBottom: '12px',
})

export const dayDividerStyles = css({
  position: 'absolute',
  right: '$3',
  top: -6,
  backgroundColor: '$grey50',
  border: '.5px solid $grey100',
  padding: '$1 $3',
  borderRadius: '$3',
  zIndex: 1,
})
